export default {
  button: {
    add: 'Adicionar',
    insert: 'Inserir',
    update: 'Atualizar',
    cancel: 'Cancelar',
    duplicate: 'Duplicar',
    rectify: 'Retificar',
    back: 'Atrás',
    delete: 'Eliminar',
    search: 'Procurar',
    save: 'Guardar',
    continue: 'Continuar',
    send: 'Enviar',
    issue: 'Emitir',
    export: 'Exportar {0}',
    accept: 'Aceitar',
    close: 'Fechar',
    watchAll: 'Ver todos',
    undo: 'Anular',
    newElement: 'Novo elemento',
    create: 'Criar',
    watchConditions: 'Ver condições',
    reject: 'Recusar',
    unreject: 'Anular Recusa',
    view: 'Detalhe da fatura',
    edit: 'Editar',
    ok: 'Ok',
    cancelInvoice: 'Anular',
    acceptCancel: 'Aceitar anulação',
    rejectCancel: 'Rejeitar anulação'
  },
  sharedInfo: {
    requiredFields: '(*) Campos obrigatórios'
  },
  pagination: {
    showing: 'Mostrando'
  },
  file: {
    select: 'Selecionar arquivo',
    noneSelected: 'Nenhum arquivo selecionado'
  },
  spinner: {
    loading: 'Carregando ...',
    processing: 'Em processamento'
  },
  error: 'Ocorreu um erro'
}